import { TranslationService } from '@/utils/services/TranslationService';

import { Results } from '@/components/pages/giveaway-picker/GiveawayPickerWrapper/Results';

const GiveawayPickerResults = () => {
    return (
        <div className="flex min-h-screen items-center justify-center">
            <Results />
        </div>
    );
};

export const getStaticProps = TranslationService.getTranslationMessages('giveaway_picker');

export default GiveawayPickerResults;
